import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useBazaarVoice from 'hooks/useBazaarVoice';
import BVHelmet from 'components/consumer/PDP/BazaarVoice/BVHelmet';
import usePDPBasicDetails from '../state/context/usePDPBasicDetails';
const PDPRatingsSection = () => {
  const $ = _c(3);
  useBazaarVoice();
  const basicDetails = usePDPBasicDetails();
  const baseSku = basicDetails?.data?.sku || null;
  if (!baseSku) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <BVHelmet />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== baseSku) {
    t1 = <>{t0}<div className="min-h-[26px]"><div data-bv-show="rating_summary" data-bv-product-id={baseSku} /></div></>;
    $[1] = baseSku;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPRatingsSection;